import { useEffect, useState } from 'react';
import { FILTER_MOBILE_MAX_WIDTH_PX } from './filterTokens';

const isMobileWidth = (): boolean => typeof window !== 'undefined' && window.innerWidth <= FILTER_MOBILE_MAX_WIDTH_PX;

/** 폰 폭(≤768px)인지 — 창 크기가 바뀌면 다시 판정한다 */
export function useIsMobileWidth(): boolean {
    const [mobile, setMobile] = useState<boolean>(isMobileWidth);
    useEffect(() => {
        const onResize = (): void => setMobile(isMobileWidth());
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);
    return mobile;
}
